import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { stylesContainer } from '../../../styles/selectCardAnonimous';
import { getUserInfoSelector, selectPaymentServiceConfArrayServices, getOriginParamsSelector, getCanMultiAnalytics, isContainerTelcelSelector } from '../../../store/selectors/paymentsSelectors';
import { ClaroSDKService } from '../../../services/sdk/ClaroSDKService';
import { useClaropaySdk } from '../../../services/sdk/SDKServiceWeb.tsx';
import { deleteAllCards, executeTaggeo, getMessengerService, setAddCardFormData, setCvvForAnonimous, setPaymentMethod } from '../../../store/actions';
import dummyInputs from '../../../store/sagas/dummyAddCardForm.json';
import * as sdkclaro from '@claropay/claro-pay-sdk-v2'
import { MarkCard } from '@claropay/web-portal-sdk';
import { ClaroPayApi } from '../../../services/api/ClaroPayApi.js';
import styled, { css } from 'styled-components';
import ModalLegales from '../ModalLegales/ModalLegales.js';
import { getServicesTelcel } from '../../organisms/utils';  

const Container = styled.p`
	${props => props.$isContainerTelcel && 
		css`
			font-family: AMX-Regular;
			font-size: 12px;
			color: #222;
			line-height: 22px;
			margin: 0px;
			padding: 0px 0px 24px 0px;
		`
	}

	${props => !props.$isContainerTelcel && 
		css`
			font-family: AMX-Regular;
			font-size: 12px;
			color: #222;
			line-height: 22px;
			margin: 0px;
			padding: calc(24px - 2%) 2% 2px 2%;
		`
	}
`;

const Text = styled.span`
	${props => props.$isContainerTelcel && 
		css`
			font-family: ${props.$bold ? "AMX-Bold" : "AMX-Regular"};
			color: ${props.$color || "#222"};
			display: ${props.$display || "inline"};
			text-decoration: ${props.$textDecoration || "none"}
		`
	}

	${props => !props.$isContainerTelcel && 
		css`
			font-family: ${props.$bold ? "AMX-Bold" : "AMX-Regular"};
			color: ${props.$color || "#222"};
			display: ${props.$display || "inline"};
			text-decoration: ${props.$textDecoration || "none"}
		`
	}
`;

const AddCardForm = (props) => {

    const [inputs, setInputs] = React.useState([]);
    const [focused, setFocused] = React.useState("");
    const [isActiveContinueBtn, setIsActiveContinueBtn] = React.useState(false);
    const [isLoadingContinue, setIsLoadingContinue] = React.useState(false);
    const [showDegrade, setShowDegrade] = React.useState(false);
    const [errorText, setErrorText] = React.useState("");
	const [open, setOpen] = React.useState(false);
	const [url] = React.useState(
		props.isContainerTelcel 
			? process.env.REACT_APP_PRIVACY_CARD_TELCEL_FORM_URL 
			: process.env.REACT_APP_PRIVACY_CARD_TELCEL_FORM_URL
	);

    const styles = stylesContainer.addCard;

    React.useEffect(() => {
      const { getMessengerService } = props;
      getMessengerService("FlujoAnonimo");
    }, []);  

    const handleOnfocus = (input) => {
        setFocused(input.id);
        let inputsFilter = props.addCardFormData.inputsError 
            ? props.addCardFormData.inputsError.filter(e => (e.id !== input.id)) 
            : [];
        props.setAddCardFormData({ ...props.addCardFormData, inputsError: inputsFilter });
    }

    const handleOnBlur = (e, input) => {
        setFocused("");

        const { value } = e.target;

        let inputsFilter = props.addCardFormData.inputsError 
            ? props.addCardFormData.inputsError.filter(e => (e.id !== input.id)) 
            : [];

        if (input.errorEmpty && value.length === 0) {
            inputsFilter = [
                ...inputsFilter,
                {
                    id: input.id,
                    error: "errorEmpty"
                }
            ]
        }

        if (
            input.errorIncomplete &&
            value.length > 0 &&
            value.length < input.maxLength
        ) {
            inputsFilter = [
                ...inputsFilter,
                {
                    id: input.id,
                    error: "errorIncomplete"
                }
            ]
        }

        if (input.errorInvalid) {
            if (
                input.id === "expiration" &&
                value.length === input.maxLength
            ) {
                let curDate = new Date();

                let curMonth = curDate.getMonth();
                    curMonth = parseInt(curMonth) + 1;

                let curYear = curDate.getFullYear().toString().slice(-2);
                    curYear = parseInt(curYear);

                let inputMonth = value.slice(0,2);
                    inputMonth = parseInt(inputMonth);

                let inputYear = value.slice(-2);
                    inputYear = parseInt(inputYear);

                if (
                    curYear > inputYear || 
                    (curYear === inputYear && curMonth > inputMonth) ||
                    inputMonth < 1 || 
                    inputMonth > 12
                ) {
                    inputsFilter = [
                        ...inputsFilter,
                        {
                            id: input.id,
                            error: "errorInvalid"
                        }
                    ]
                }                
            }

            if (
                input.id === "email" &&
                value.length > 0
            ) {
                const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
                if (!regex.test(value)) {
                    inputsFilter = [
                        ...inputsFilter,
                        {
                            id: input.id,
                            error: "errorInvalid"
                        }
                    ]
                }
            }
        }

        if (!props.addCardFormData.showError) {
            props.setAddCardFormData({ ...props.addCardFormData, inputsError: inputsFilter });
        }        
    }

    const handleOnInput = (e, input) => {

        const { id } = input;
        let value = e.target.value;

        if (id === "card-number") {
            value = e.target.value.replace(/\D/g, '');

            let creditCardNumberValue = "";
            let typeCard = "";

            if (value.length <= 16) {
                creditCardNumberValue = value.replace(/(\d{4})(?=\d)/g, '$1 ');
            }

            const visaRegex = /^4[0-9]{15}$/;
            const mastercardRegex = /^5[1-5][0-9]{14}$/;

            if (visaRegex.test(value)) {
                typeCard = "visa";
            }
            else if (mastercardRegex.test(value)) {
                typeCard = "mastercard";
            }
            else {
                typeCard = "";
            }

            props.setAddCardFormData({ ...props.addCardFormData, creditCardNumberValue, typeCard, showError: false })
        }

        if (id === "name") {
            if (value.length <= input.maxLength) {
                let formattedValue = value.replace(/[áéíóúÁÉÍÓÚüÜñÑ]/g, "");
                formattedValue = formattedValue.replace(/[^a-zA-Z ]/g, "");
                props.setAddCardFormData({ ...props.addCardFormData, userNameValue: formattedValue, showError: false });
            }
        }

        if (id === "expiration") {
            value = value.slice(0, 5);

            const numericValue = value.replace(/\D/g, '');
            let formattedValue = numericValue;

            if (numericValue.length > 2 && numericValue.indexOf('/') === -1) {
                formattedValue = `${numericValue.slice(0, 2)}/${numericValue.slice(2, 4)}`;
            }

            props.setAddCardFormData({ ...props.addCardFormData, expirationCardValue: formattedValue, showError: false });
        }

        if (id === "cvv") {
            const numericValue = value.replace(/\D/g, '');
            if (numericValue.length <= input.maxLength) {
                props.setAddCardFormData({ ...props.addCardFormData, cvvValue: numericValue, showError: false });
            }
        }

        if (id === "email") {
            if (value.length <= input.maxLength) {
                props.setAddCardFormData({ ...props.addCardFormData, emailValue: value, showError: false });
            }
        }
    }

    const getMarkCard = (brand) => {
        switch (brand) {
            case "visa":
            return MarkCard.VISA;
            case "mastercard":
            return MarkCard.MASTERCARD;
            case "amex":
            return MarkCard.AMERICANEXPRESS;
            case "carnet":
            return MarkCard.CARNET;
            case "n2":
            return MarkCard.CLAROPAY;
            case "adelanto":
            return MarkCard.ADELANTO;
            case "claropayCredito":
            return MarkCard.CLAROPAY_CREDITO;
        }
    };

    const handleOnClickContinueBtn = (e) => {
        const { expirationCardValue, userNameValue, creditCardNumberValue, isTemporalClaroId } = props.addCardFormData;
        const {isContainerTelcel, originAnalytic, canR1, canR1Flag} = props;

        if (!isLoadingContinue) {
            let typeCard = "";

            if (props.addCardFormData.typeCard === "visa") {
                typeCard = "Visa";
            }

            if (props.addCardFormData.typeCard === "mastercard") {
                typeCard = "MasterCard";
            }
            if(props.canMultiAnalytics && props.isContainerTelcel) {
                const originAnalyticArray = props.originAnalytic? props.originAnalytic.split(",") : [];
                props.executeTaggeo({
                    eventName: "pay_service_or_tae",
                    seccion: "servicios",
                    subseccion: getServicesTelcel(props.serviceInfo.serviceId),
                    origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
                    pantalla: "formulario de pago",
                    nombreServicio: props.serviceInfo && props.serviceInfo.serviceName ? props.serviceInfo.serviceName : props.serviceInfo.categoryName,
                    brand: typeCard.toLowerCase(),
                    tipoElemento: "boton",
                    nombreElemento: "continuar",
                    trackAction: true,
                });
            } else {
                props.executeTaggeo({
                    step: "Formulario de pago",
                    brand: typeCard,
                    action: "Click modal Continuar",
                    modal_id: "Ingresa una tarjeta"
                });
            }
            //

            const expirationCardValueSplit = expirationCardValue.split("/");
            const patternVisa = new RegExp("^4[0-9]{0,}$");
            const patternMastercard = new RegExp("^(5[1-{5|7|8}]|222[1-9]|22[3-9]|2[2-7]|27[01]|2720)[0-9]{0,}$");
            
            let brand;
            const cardNum = creditCardNumberValue.replaceAll(" ", "");
            if (
                cardNum &&
                cardNum.length > 1 &&
                patternVisa.test(`${cardNum.substring(0, 6)}`)
            ) {
                brand = "visa";
            } else if (
                cardNum &&
                cardNum.length > 1 &&
                patternMastercard.test(`${cardNum.substring(0, 6)}`)
            ) {
                brand = "mastercard";
            }
            const cardData = {
                name: userNameValue,
                cvv2: "123",
                yearExpiration: expirationCardValueSplit[1],
                monthExpiration: expirationCardValueSplit[0],
                pan: cardNum,
                mark: `${getMarkCard(brand)}`,
                deviceData: canR1 || null,
                canDeviceData: canR1Flag || false
				// acceptTermsAndConditions: true, 
            }

            // Save card flux
            const tokenizeCard = async () => {
                let errors = {};
                try {
                    // Is loading true
                    setIsLoadingContinue(true);

                    // Get tokens from web sdk
                    const tokenFull = await ClaroSDKService.getFullToken();

                    // Call appsync from web sdk
                    // await useClaropaySdk().appSync(
                    //     process.env.REACT_APP_APPSYNC_COUNTRY_ID,
                    //     process.env.REACT_APP_APPSYNC_BUNDLE_ID,
                    //     process.env.REACT_APP_APPSYNC_BUNDLE_VERSION,
                    //     process.env.REACT_APP_APPSYNC_BANK_ID,
                    // );

                    // Set token
                    await useClaropaySdk().setToken(isTemporalClaroId, tokenFull);

                    // load profile
                    await useClaropaySdk().getProfile();
                    
                    console.debug("ClaroPayApi.deleteAllCardsApi, ", props.isTemporalClaroId);
                    if(props.isTemporalClaroId){
                        // Delete cards
                        await ClaroPayApi.deleteAllCardsApi(props.userInfo, tokenFull);
                    }

                    // Save card
                    let saveCard = await useClaropaySdk().saveCard(cardData);
                        saveCard = JSON.parse(saveCard);
                    
                    const { success } = saveCard;
                    const codeErrorCanDevice =
                      saveCard &&
                      saveCard.data &&
                      saveCard.data.detail &&
                      saveCard.data.detail &&
                      saveCard.data.detail.info &&
                      saveCard.data.detail.info.codeErrorCanDevice || false;
                    if (codeErrorCanDevice) {
                      errors = { ...errors, codeErrorCanDevice };
                    }

                    if (!success) {
                        handleSaveCardError({
                            ...errors
                        });
                        if(props.canMultiAnalytics && props.isContainerTelcel) {
                            const originAnalyticArray = props.originAnalytic? props.originAnalytic.split(",") : [];
                            props.executeTaggeo({
                                eventName: "pay_service_or_tae",
                                seccion: "servicios",
                                subseccion: getServicesTelcel(props.serviceInfo.serviceId),
                                origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
                                pantalla: "formulario de pago",
                                nombreServicio: props.serviceInfo && props.serviceInfo.serviceName ? props.serviceInfo.serviceName : props.serviceInfo.categoryName,
                                tipoElemento: "modal",
                                nombreElemento: "ingresa una tarjeta de credito o debito para hacer tus pagos",
                                error_mensajeBack: saveCard.data && saveCard.data.error ? saveCard.data.error : "error de usuario",
                                error_mensaje: "Alguno de los datos que ingresaste es incorrecto, por favor verificalos",
                                error_codigoEstatus: saveCard.data && saveCard.data.bSdkCode ? saveCard.data.bSdkCode : "500",
                                operacionError_se: "1",
                                operacion_nombre: "registro de tarjeta",
                                operacion_tipoRespuesta: "error",
                                operacion_variante: "tokenizacion",
                                trackState: true,
                            });
                        } 
                    } else {
                        if(props.canMultiAnalytics  && isContainerTelcel) {
                            // taggeo to singular card save success
                            const originAnalyticArray = originAnalytic? originAnalytic.split(",") : [];
                            if(!props.isAnonimous){
                                props.executeTaggeo({
                                    seccion: "financiero",
                                    subseccion: "pagos",
                                    eventName: "payment_method_added",
                                    pantalla: "tarjeta agregada",
                                    transaccion_tipoTarjeta: typeCard.toLowerCase(),
                                    trackState: true,
                                    origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services"
                                });
                            }
                            props.executeTaggeo({
                                eventName: "pay_service_or_tae",
                                seccion: "servicios",
                                subseccion: getServicesTelcel(props.serviceInfo.serviceId),
                                origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
                                pantalla: "formulario de pago",
                                nombreServicio: props.serviceInfo && props.serviceInfo.serviceName ? props.serviceInfo.serviceName : props.serviceInfo.categoryName,
                                brand: typeCard.toLowerCase(),
                                operacion_nombre: "registro de tarjeta",
                                operacion_tipoRespuesta: "exito",
                                operacion_variante: "tokenizacion",
                                operacionExito_se: "1",
                                trackState: true,
                            });
                        }
                        // Set cvv for anonimous
                        props.setCvvForAnonimous(props.addCardFormData.cvvValue);

                        // Set value to show snackbar or go towards confirmation ticket 
                        if (props.handleValidateIfSentToTicket) {
                            props.handleValidateIfSentToTicket(true);                       
                        }

                        // Show snackbar                        
                        if (!props.isAnonimous) { 
                            const url = {
                                app: "startEventNoClose",
                                to : "showContainerSnackBar",
                                parameters: JSON.stringify({show: "true",name:"highlightMB",cp:"CP0029",flow:"MiniAppTelcel",type:"positive"}),
                            };
                            const snackbarSaveCardSuccessParams = JSON.stringify(url)
                            sdkclaro.getInstance().openNative(snackbarSaveCardSuccessParams);
                            if(props.canMultiAnalytics && props.isContainerTelcel) {
                                const originAnalyticArray = props.originAnalytic? props.originAnalytic.split(",") : [];
                                props.executeTaggeo({
                                        eventName: "pay_service_or_tae",
                                        seccion: "servicios",
                                        subseccion: props.serviceInfo && props.serviceInfo.serviceId && getServicesTelcel(props.serviceInfo.serviceId),
                                        origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
                                        pantalla: "formulario de pago",
                                        nombreServicio: props.serviceInfo && props.serviceInfo.serviceName ? props.serviceInfo.serviceName : props.serviceInfo.categoryName,
                                        tipoElemento: "snackbar",
                                        nombreElemento: "tu tarjeta ya se guardo con telcel",
                                        operacion_nombre: "registro de tarjeta",
                                        operacion_tipoRespuesta: "exito",
                                        operacion_variante: "tokenizacion",
                                        operacionExito_se: "1",
                                        trackState: true,
                                });
                            } else {
                                props.executeTaggeo({
                                    step: "Formulario de pago",
                                    action: "View snackbar Tarjeta guardada",
                                    eventName:"pay_service_or_tae",
                                    service: props && props.paymentsConfig && props.paymentsConfig.tagServiceId
                                });
                            }
                        }

                        // Hide error and set default payment method 
                        props.setAddCardFormData({ ...props.addCardFormData, showError: false, handleSetDefaultPaymentMethod: true });
                        
                        // Is loading false
                        setIsLoadingContinue(false);

                        // Close modal
                        props.handleCloseSelectCardAnonimous();

                        // Launch search card
                        props.setPaymentMethod({ cardId: saveCard.data.cardId });

                        // Set value tu show loader 
                        if (props.handleShowLoaderWaitSubmit) {
                            props.handleShowLoaderWaitSubmit(true);
                        }

                        // Clear customerIndex
                        ClaroSDKService.clearCustomerIndex();
                    }
                } catch (error) {
                    handleSaveCardError();
                }

            }

            // Launch save card flux
            tokenizeCard();
        }
    }

    const handleSaveCardError = (errors = {}) => {
      setIsActiveContinueBtn(false);
      setIsLoadingContinue(false);
      if(!errors.hasOwnProperty("codeErrorCanDevice")){
        // eliminar 
        delete props.addCardFormData.codeErrorCanDevice;
      }
      props.setAddCardFormData({
        ...props.addCardFormData,
        ...errors,
        showError: true,
      });
    };
    
    React.useEffect(() => {
        const formElements = dummyInputs.elementsAddCard;

        if (formElements) {
            setInputs(formElements);
        }
    }, [props.configServices]);

    React.useEffect(() => {

        const { 
            inputsError, 
            creditCardNumberValue, 
            userNameValue, 
            expirationCardValue,
            showError,
            cvvValue
        } = props.addCardFormData;

        if (inputsError && creditCardNumberValue && userNameValue && expirationCardValue && cvvValue) {
            setIsActiveContinueBtn(
                !showError &&
                inputsError.length === 0 &&
                creditCardNumberValue.length === 19 &&
                userNameValue.length > 0 &&
                expirationCardValue.length === 5 &&
                cvvValue.length === 3
                    ? true
                    : false
            );
        }
    }, [props.addCardFormData]);

    React.useEffect(() => {
        if (props.messages) {
            let CP = props.messages.find(cp => cp.code === "CP0023");
          if (
            props.addCardFormData &&
            props.addCardFormData.codeErrorCanDevice
          ) {
            CP = props.messagesAnonymousFlow.find(
              (cp) => cp.code === props.addCardFormData.codeErrorCanDevice
            );
          }
            if (CP && CP.data) {
                const { data } = CP;
                if(props.canMultiAnalytics && props.isContainerTelcel &&  props.addCardFormData.showError) {
                    const originAnalyticArray = props.originAnalytic? props.originAnalytic.split(",") : [];
                    props.executeTaggeo({
                        eventName: "pay_service_or_tae",
                        seccion: "servicios",
                        subseccion: getServicesTelcel(props.serviceInfo.serviceId),
                        origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
                        pantalla: "formulario de pago",
                        nombreServicio: props.serviceInfo && props.serviceInfo.serviceName ? props.serviceInfo.serviceName : props.serviceInfo.categoryName,
                        tipoElemento: "modal",
                        nombreElemento: "ingresa una tarjeta de credito o debito para hacer tus pagos",
                        error_mensajeBack: data.message,
                        error_mensaje: data.message,
                        error_codigoEstatus: data.code,
                        operacionError_se: "1",
                        operacion_nombre: "registro de tarjeta",
                        operacion_tipoRespuesta: "error",
                        operacion_variante: "tokenizacion",
                        trackState: true,
                    });
                } 
                setErrorText(data.message);
            }
        
        if (CP && CP.data) {
          const { data } = CP;
          if (
            props.addCardFormData &&
            props.addCardFormData.codeErrorCanDevice
          ) {
            setErrorText(`${data.subject} <br/> ${data.message}`);
          } else {
            setErrorText(data.message);
          }
        }
        }
    }, [props.messages, props.messagesAnonymousFlow, props.addCardFormData])

    React.useEffect(() => {
        const cardContainer = document.querySelector("#cardContainer");

        cardContainer.addEventListener("scroll", () => {
            setShowDegrade(cardContainer.scrollTop > 30 ? true : false)
        })
    }, []);

    React.useEffect(() => {
        if (props.addCardFormData.isOpenAddCardForm) {
            if(props.canMultiAnalytics && props.isContainerTelcel && props.isOpen) {
                const originAnalyticArray = props.originAnalytic? props.originAnalytic.split(",") : [];
                props.executeTaggeo({
                    eventName: "pay_service_or_tae",
                    seccion: "servicios",
                    subseccion: getServicesTelcel(props.serviceInfo.serviceId),
                    origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
                    pantalla: "formulario de pago",
                    nombreServicio: props.serviceInfo && props.serviceInfo.serviceName ? props.serviceInfo.serviceName : props.serviceInfo.categoryName,
                    tipoElemento: "modal",
                    nombreElemento: "ingresa una tarjeta de credito o debito para hacer tus pagos",
                    trackState: true,
                });
            } else {
                if(!props.isContainerTelcel){
                    props.executeTaggeo({
                        step: "Formulario de pago",
                        action: "View modal",
                        modal_id: "Ingresa una tarjeta"
                    });
                }
            }
        }
    }, [props.isOpen])

	const handleOnClick = () => {
		setOpen(!open);
	}

    return (
        <div style={{ overflowY: 'scroll', height: "100%", position: "fixed", width: "calc(100% - 32px)" }} id='cardContainer' role='dialog' aria-modal="true" aria-labelledby='modalTitle'>
            {/* Degrade */}
            {
                showDegrade &&
                <div style={{
                    position: "fixed",
                    width: "inherit",
                    height: "45px",
                    background: "linear-gradient(rgba(255,255,255,0.9), rgba(255,255,255,0.7), rgba(255,255,255,0.4), rgba(255,255,255,0)"
                }} />
            }

            {/* Header logos */}
            <div style={styles.headerContainer}>
                <img src={`${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}logo_mastercard_y_visa.png` } style={styles.headerLogos} alt='' />
            </div>

            {/* Header title */}
            <h2 style={styles.title} id='modalTitle'>
                <span style={styles.titleLight}>
                    Ingresa una tarjeta
                </span>
                &nbsp;
                <span style={styles.titleDark}>
                    de crédito o débito
                </span>
                &nbsp;
                <span style={styles.titleLight}>
                    para hacer tus pagos
                </span>
            </h2>

            {/* Header subtitle */}
            <p style={styles.subtitle}>
                <span style={styles.subtitleLight}>
                    Por el momento sólo aceptamos
                </span>
                &nbsp;
                <span style={styles.subtitleDark}>
                    VISA y MasterCard
                </span>
            </p>

            {/* Inputs */}
            {
                inputs.map((input, index) => {
                    /* Style validation for empty or error value and type card */
                    let styleWrapper = styles.wrapper;
                    let styleLabel = styles.inputLabel;
                    let styleInput = styles.inputControl;
                    let errorMessage = undefined;

                    if (focused === input.id) {
                        styleLabel = styles.inputLabelFocused;
                        styleInput = styles.inputControlFocused;
                    }

                    if (input.infoMessage) {
                        styleInput = {
                            ...styleInput,
                            margin: "0px 0px 8px 0px"
                        }
                    }

                    const hasError = props.addCardFormData.inputsError 
                        ? props.addCardFormData.inputsError.find(i => i.id === input.id)
                        : undefined;

                        if (hasError) {
                        switch (hasError.error) {
                            case "errorEmpty":
                                styleLabel = styles.inputLabelError;
                                styleInput = styles.inputControlError;
                                errorMessage = input.errorEmpty
                                break;

                            case "errorIncomplete":
                                styleLabel = styles.inputLabelError;
                                styleInput = styles.inputControlError;
                                errorMessage = input.errorIncomplete
                                break;

                            case "errorInvalid":
                                styleLabel = styles.inputLabelError;
                                styleInput = styles.inputControlError;
                                errorMessage = input.errorInvalid
                                break;

                            default:
                                break;
                        }
                    }

                    if (input.id === "card-number") {
                        if (props.addCardFormData.typeCard === "visa") {
                            styleInput = {
                                ...styleInput,
                                backgroundImage: "url(/images/Visa-Logo.png)",
                                backgroundPosition: "right 16px top",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "auto 18px"
                            }
                        }
                        else if (props.addCardFormData.typeCard === "mastercard") {
                            styleInput = {
                                ...styleInput,
                                backgroundImage: "url(/images/mastercard-logo-logok-15.png)",
                                backgroundPosition: "right 16px top",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "auto 18px"
                            }
                        }
                    }

                    if (input.id === "cvv") {
                        styleWrapper = {
                            ...styleWrapper,
                            backgroundImage: `url(${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}cap_src_ct_card_form_cvv.png)`,
                            backgroundPosition: "right 2px top 15px",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "auto 31.28px",
                        }
                    }

                    /* Set value */
                    let inputValue = "";

                    if (input.id === "card-number") {
                        inputValue = props.addCardFormData.creditCardNumberValue
                    }

                    if (input.id === "name") {
                        inputValue = props.addCardFormData.userNameValue
                    }

                    if (input.id === "expiration") {
                        inputValue = props.addCardFormData.expirationCardValue
                    }

                    if (input.id === "cvv") {
                        inputValue = props.addCardFormData.cvvValue
                    }

                    if (input.id === "email") {
                        inputValue = props.addCardFormData.emailValue
                    }

                    return (
                        <div key={index} style={styleWrapper}>
                            <label htmlFor={input.id} style={styleLabel}>
                                {input.label}
                            </label>
                            <input
                                style={styleInput}
                                type='text'
                                inputMode={input.inputMode ? input.inputMode : "text"}
                                placeholder={input.placeholder}
                                onFocus={() => handleOnfocus(input)}
                                onBlur={(e) => handleOnBlur(e, input)}
                                onChange={(e) => handleOnInput(e, input)}
                                maxLength={input.maxLength}
                                value={inputValue} 
                                id={input.id}
                                aria-describedby={!errorMessage ? undefined : `help_${input.id}`} />
                            
                            {
                                input.infoMessage &&
                                <p style={{ ...styles.infoMessage, margin: '0px 0px 24px 0px' }}>
                                    {input.infoMessage}
                                </p>
                            }
                            
                            {
                                errorMessage &&
                                <p style={{ ...styles.errorMessage, marginBottom: '0px 0px 24px 0px' }} id={`help_${input.id}`} aria-live='assertive'>
                                    {errorMessage}
                                </p>
                            }
                        </div>
                    )
                })
            }

            {/* Error wording */}
            {
                props.addCardFormData.showError &&
                <div style={ styles.errorWordingWrap }>
                    <div style={ styles.errorWordingLeft } />
                    <div style={ styles.errorWordingRight }>
                        <span dangerouslySetInnerHTML={{ __html: errorText }} />
                    </div>                    
                </div>
            }

			{/* Privacy */}
			<Container $isContainerTelcel={props.isContainerTelcel}>
				Al presionar&nbsp;
				<Text 
					$isContainerTelcel={props.isContainerTelcel}
					$bold={true}>
					‘Continuar’
				</Text>, estás aceptando el<br />
				<Text
					$isContainerTelcel={props.isContainerTelcel}
					$bold={true}
					$display="inline-block"
					$textDecoration="underline"
					$color="#0071D1"
					onClick={() => handleOnClick()}>
					Aviso de Privacidad de uso del servicio.
				</Text>
			</Container>

			{
				open &&
				<ModalLegales 
					url={url}
					handleOnClick={handleOnClick}
				/>
			}

            {/* Continue Button */}
            <button
                disabled={!isActiveContinueBtn}
                style={isActiveContinueBtn ? (isLoadingContinue ? styles.continueButtonActiveLoading : styles.continueButtonActive) : styles.continueButtonInactive}
                onClick={(e) => handleOnClickContinueBtn(e)}>
                {
                    !isLoadingContinue
                        ?
                        <>
                            Continuar
                        </>
                        :
                        <img src='/images/white-loading.gif' height={25} />
                }
            </button>

            {/* Space under button */}
            <br />
            <br />
            <br />
            <br />
            &nbsp;
        </div>
    )

}

const mapStateToProps = (state) => {
    const { payments } = state;
    const configServices = selectPaymentServiceConfArrayServices(payments);
    const originAnalytic = getOriginParamsSelector(state);
    const isContainerTelcel = isContainerTelcelSelector(state);
    const isTemporalClaroId = payments.isTemporalClaroId;
    const messages = payments.messages;
    const messagesAnonymousFlow = payments.messagesAnonymousFlow;
    const addCardFormData = payments.addCardFormData;
    const paymentsConfig = payments.PAYMENT_SERVICE_CONF;
    const userInfo = getUserInfoSelector(state);
    const isAnonimous = payments.isAnonimous
    const canR1 = payments.canR1 || null; 
    const canR1Flag = payments.canR1Flag || false;
    return {
        configServices,
        isTemporalClaroId,
        messages,
        addCardFormData,
        paymentsConfig,
        userInfo,
        isAnonimous,
        isContainerTelcel,
        originAnalytic,
        canMultiAnalytics: getCanMultiAnalytics(state),
        canR1,
        canR1Flag,
        messagesAnonymousFlow
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            setPaymentMethod,
            setAddCardFormData,
            executeTaggeo,
            deleteAllCards,
            setCvvForAnonimous,
            getMessengerService
        },
        dispatch,
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(AddCardForm)